import { render, staticRenderFns } from "./MateriaisBonus.vue?vue&type=template&id=2bf9a27f&"
import script from "./MateriaisBonus.vue?vue&type=script&lang=js&"
export * from "./MateriaisBonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports